module.exports = __webpack_public_path__ + "img/29 cumplir.24e153ca.jpg";